module.exports = __webpack_public_path__ + "static/media/dark-motion-constellation-simulation.f5e4fc3.mp4";